import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import * as React from 'react';
export default {
  PolypaneIntro,
  React
};